module.exports = __webpack_public_path__ + "static/material-cotton.ca635b71.svg";